import { render, staticRenderFns } from "./ApplicationRecordDetails.vue?vue&type=template&id=348a2c4c&scoped=true"
import script from "./ApplicationRecordDetails.vue?vue&type=script&lang=js"
export * from "./ApplicationRecordDetails.vue?vue&type=script&lang=js"
import style0 from "./ApplicationRecordDetails.vue?vue&type=style&index=0&id=348a2c4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a2c4c",
  null
  
)

export default component.exports